import React from 'react'
import { classnames } from '../../utils/classnames'
import './styles/Close.css'

export const Close = ({ onClick, color = '' }) => (
	<div onClick={onClick} className={classnames('Close', color)} />
)
